{
  "fr": {
    "subscribe_confirmation_html": "Vous êtes sur le point de réaliser un investissement pour le projet %{project_name}, en cliquant sur confirmer, <b>%{total_with_fees_html} seront débités de votre porte-monnaie</b>.",
    "sdd_confirmation_html": "Vous êtes sur le point de réaliser un investissement pour le projet %{project_name}, en cliquant sur confirmer, <b>un prélèvement de %{total_with_fees_html} sera initié sur votre compte bancaire</b>."
  }
}
